import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const SparkplugFilledIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M10.244 18.2269H12.4286V19.6669H10.244V21.1069H12.3159C13.1112 21.1069 13.7559 20.4622 13.7559 19.6669V16.7868H10.244V18.2269ZM10.244 15.3469H13.7559V13.9069H10.244V15.3469ZM14.3413 9.71099V5.82024L13.1706 4.64959V2.89355H10.8293V4.64959L9.65864 5.82024V9.71099H8.48792V12.4669H15.512V9.71099H14.3413ZM12.9013 9.71099H11.0986V6.41668L11.8475 5.66778L11.9999 5.51538L12.1524 5.66778L12.9013 6.41668V9.71099Z" />
      <path d="M12.9013 9.71099H11.0986V6.41668L11.8475 5.66778L11.9999 5.51538L12.1524 5.66778L12.9013 6.41668V9.71099Z" />
    </SvgIcon>
  );
});
